/* eslint-disable @typescript-eslint/no-unused-vars */
import { Environment } from '../../../environment';
import { ApiFinanceira } from '../axiosfinanceiro';
import axios, { AxiosError, isAxiosError } from 'axios';

export interface IListagem {
  idcontaspagar: string;
  nome: string;
  cpf: string;
  numerodoc: string;
  dataemissao: Date;
  vencimento: Date;
  valorpagar: number; 
}

export interface IConfirmarBoleto{
  idcontaspagar: string;
  nossonumero: string;
  boleto: boolean;
}

type TotalCount = {
    data: IListagem[];
    totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAll = async (page = 1, parceiro = '', tipo='', datainicial: string, datafinal: string): Promise<TotalCount | Error> => {
  try {

    const urlRelativa = `/confirmarboleto?page=${page}&limit=${Environment.LIMITE_DE_LINHAS}&parceiro=${parceiro}&tipo=${tipo}&datainicial=${datainicial}&datafinal=${datafinal}`;

    const { data, headers } = await ApiFinanceira.get(urlRelativa); 

    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const ConfirmarBoleto = async (Confirmar: IConfirmarBoleto): Promise<void | Error> => {
  try {  
    await ApiFinanceira.put('/confirmarboleto', Confirmar); 
    return;   
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const ConfirmarBoletoService = {  
  getAll, 
  ConfirmarBoleto,
};